<template>
  <div class="comment-thread" :class="{ 'is-reply': depth > 0 }">
    <div class="comment-item">
      <v-avatar size="28" color="primary" class="comment-avatar">
        {{ initials(comment.displayName || comment.authorName || '?') }}
      </v-avatar>
      <div class="comment-content">
        <div class="comment-meta">
          <span class="comment-author">
            {{ comment.displayName || comment.username || comment.authorName || 'Unknown' }}
          </span>
          <span class="comment-date">{{ formatDate(comment.createdAt) }}</span>
        </div>
        <div class="comment-body">{{ comment.body }}</div>
        <button class="reply-btn" @click="$emit('reply', comment.commentId)">
          Reply
        </button>
      </div>
    </div>

    <!-- Nested replies (recursive) -->
    <div v-if="comment.replies?.length" class="replies">
      <CommentThread
        v-for="reply in comment.replies"
        :key="reply.commentId"
        :comment="reply"
        :depth="depth + 1"
        @reply="$emit('reply', $event)"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  comment: { type: Object, required: true },
  depth:   { type: Number, default: 0 },
})
defineEmits(['reply'])

function initials(name) {
  return name?.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() || '?'
}
function formatDate(d) {
  if (!d) return ''
  return new Date(d).toLocaleDateString('da-DK', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'
  })
}
</script>

<style scoped>
.comment-thread { margin-bottom: 12px; }
.comment-item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
.comment-avatar { flex-shrink: 0; font-size: 0.7rem; font-weight: 700; }
.comment-content { flex: 1; min-width: 0; }
.comment-meta {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 3px;
}
.comment-author {
  font-size: 0.78rem;
  font-weight: 700;
}
.comment-date {
  font-size: 0.68rem;
  opacity: 0.5;
}
.comment-body {
  font-size: 0.82rem;
  line-height: 1.5;
  white-space: pre-wrap;
}
.reply-btn {
  font-size: 0.7rem;
  color: rgba(var(--v-theme-primary), 1);
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 0;
  margin-top: 3px;
  opacity: 0.7;
}
.reply-btn:hover { opacity: 1; }
.is-reply {
  padding-left: 20px;
  border-left: 2px solid rgba(var(--v-theme-on-surface), 0.08);
  margin-left: 14px;
}
.replies { margin-top: 8px; }
</style>
